<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="3500"
  >
    {{ message }}
    <v-btn
      text
      @click="snackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>
<script>
import bus from '@/plugins/event-bus'

export default {
  name: 'Toast',
  data: function () {
    return {
      message: '',
      snackbar: false,
    }
  },
  methods: { },
  mounted: function () {
    bus.$on('toast', (message) => {
      if (this.snackbar === true) {
        this.snackbar = false
      }

      this.$nextTick(() => {
        this.message = message
        this.snackbar = true
      })
    })
  },
}
</script>
